import React from 'react';
import { Calendar, Mail, Phone, Building2, Briefcase } from 'lucide-react';
import Card from '../../../shared/components/Card';

const ProfileHeader = ({ profile }) => {
  if (!profile) return null;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <Card className="p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-3xl font-bold">
            {profile.first_name} {profile.middle_name} {profile.last_name}
          </h1>
          <p className="text-blue-100 mt-1">{profile.position || 'No position set'}</p>
        </div>
        {profile.employeeId && (
        <div className="bg-white bg-opacity-20 rounded-lg px-4 py-2">
          <span className="text-sm font-medium">Employee ID: {profile.employeeId || 'N/A'}</span>
        </div>)}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        <div className="flex items-center space-x-3">
          <Mail size={20} className="text-blue-200" />
          <div>
            <p className="text-sm text-blue-200">Email</p>
            <p className="font-medium">{profile.email}</p>
          </div>
        </div>

        {profile.mobile && (
          <div className="flex items-center space-x-3">
            <Phone size={20} className="text-blue-200" />
            <div>
              <p className="text-sm text-blue-200">Phone</p>
              <p className="font-medium">{profile.mobile}</p>
            </div>
          </div>
        )}

        {profile.department && (
          <div className="flex items-center space-x-3">
            <Building2 size={20} className="text-blue-200" />
            <div>
              <p className="text-sm text-blue-200">Department</p>
              <p className="font-medium">{profile.department}</p>
            </div>
          </div>
        )}

        {profile.joinedAt && (
          <div className="flex items-center space-x-3">
            <Calendar size={20} className="text-blue-200" />
            <div>
              <p className="text-sm text-blue-200">Joined</p>
              <p className="font-medium">{formatDate(profile.joinedAt)}</p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default ProfileHeader;